/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/2022
 */

import React from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { EmployeeNameFormat } from "../../interfaces/Global";

export interface EmployeeNameFormatSelectorProps {
	value: string
	setValue: (format: EmployeeNameFormat) => void
}

export default function EmployeeNameFormatSelector(props: EmployeeNameFormatSelectorProps) {

	return (
		<FormControl variant={"standard"}>
			<InputLabel>Employee Name Format</InputLabel>
			<Select
				variant={"standard"}
				value={props.value}
				onChange={(event) => props.setValue(event.target.value as EmployeeNameFormat)}
			>
				<MenuItem value={"full"}>Full Name (e.g. Dolores Abernathy)</MenuItem>
				<MenuItem value={"first-initial"}>First Name and Initial (e.g. Dolores A)</MenuItem>
				<MenuItem value={"first"}>First Name (e.g. Dolores)</MenuItem>
				<MenuItem value={"last"}>Last Name (e.g. Abernathy)</MenuItem>
				<MenuItem value={"initials"}>Initials (e.g. DA)</MenuItem>
				<MenuItem value={"slack-handle"}>Slack Handle (e.g. @dolores)</MenuItem>
				<MenuItem value={"off"}>Disabled</MenuItem>
			</Select>
			<FormHelperText>Employees names in the Slack message will be formatted according to this selection.</FormHelperText>
		</FormControl>
	);

}